import React, { useEffect, useState } from 'react';
import { ConfigClientType } from '../types/ConfigClientType';

type WcbTimeSelectProps = {
    iimclient: ConfigClientType;
    wcbTimes: Array<string>;
    changeSelectedTime: Function;
};

const WcbTimeSelect = ({ iimclient, wcbTimes, changeSelectedTime }: WcbTimeSelectProps) => {
    const segment = iimclient.segment;

    const initialTime = wcbTimes.length ? wcbTimes[0] : '';
    const [selectedTime, setSelectedTime] = useState(initialTime);

    useEffect(() => {
        if (initialTime !== '') {
            setSelectedTime(initialTime);
            changeSelectedTime(initialTime);
        }
    }, [wcbTimes]);

    return (
        <select
            name="wcb-time"
            id="wcb-time"
            className="if dropdown-select"
            aria-labelledby="wcb-labeltime"
            value={selectedTime}
            onChange={(e) => {
                setSelectedTime(e.target.value);
                changeSelectedTime(e.target.value);
            }}
        >
            {wcbTimes.length ? (
                wcbTimes.map((time, index) => (
                    <option key={index} value={time}>
                        {time}
                    </option>
                ))
            ) : (
                <option value="" disabled hidden>
                    {segment ? segment.labelnotimeselected : 'labelnotimeselected'}
                </option>
            )}
        </select>
    );
};

export default WcbTimeSelect;
